export interface ComicChapter {
  id: string;
  title: string;
  chapterNumber: number;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  categories: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  favorites: number;
  updateDate: string;
  chapters: ComicChapter[];
}

export const categories = [
  { slug: 'shaonian', name: '少年漫画', icon: 'ri-sword-line', color: 'primary' },
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', color: 'accent' },
  { slug: 'xuanhuan', name: '玄幻', icon: 'ri-magic-line', color: 'secondary' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', color: 'primary' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', color: 'secondary' },
  { slug: 'xuan yi', name: '悬疑', icon: 'ri-search-eye-line', color: 'accent' },
  { slug: 'maoxian', name: '冒险', icon: 'ri-compass-3-line', color: 'primary' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', color: 'secondary' },
  { slug: 'jingsong', name: '惊悚', icon: 'ri-ghost-line', color: 'accent' },
  { slug: 'xiuzhen', name: '修真', icon: 'ri-star-line', color: 'primary' },
  { slug: 'dushi', name: '都市', icon: 'ri-building-line', color: 'secondary' },
  { slug: 'guzhuang', name: '古装', icon: 'ri-ancient-gate-line', color: 'accent' },
];

export const comics: Comic[] = [
  {
    id: 'mitao-shaonian',
    title: '蜜桃少年',
    author: '桃花仙人',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20cover%20featuring%20a%20young%20handsome%20boy%20with%20peach%20blossom%20petals%20floating%20around%20him%2C%20soft%20warm%20pink%20and%20golden%20tones%2C%20dreamy%20atmosphere%2C%20anime%20art%20style%2C%20clean%20composition%2C%20delicate%20lighting&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '少年林枫意外获得蜜桃仙子的传承，从此踏上修真之路。在这个充满奇遇与挑战的世界里，他结识了一群志同道合的伙伴，共同面对强大的敌人，揭开尘封千年的秘密。',
    categories: ['shaonian', 'xiuzhen', 'maoxian'],
    status: '连载中',
    rating: 9.6,
    views: 12580000,
    favorites: 890000,
    updateDate: '2026-08-03',
    chapters: [
      { id: 'ch-1', title: '第一章：意外的传承', chapterNumber: 1, updateDate: '2026-01-15' },
      { id: 'ch-2', title: '第二章：灵力觉醒', chapterNumber: 2, updateDate: '2026-01-22' },
      { id: 'ch-3', title: '第三章：初次试炼', chapterNumber: 3, updateDate: '2026-01-29' },
      { id: 'ch-4', title: '第四章：相遇伙伴', chapterNumber: 4, updateDate: '2026-02-05' },
      { id: 'ch-5', title: '第五章：秘境探险', chapterNumber: 5, updateDate: '2026-02-12' },
      { id: 'ch-6', title: '第六章：突破瓶颈', chapterNumber: 6, updateDate: '2026-02-19' },
      { id: 'ch-7', title: '第七章：神秘来客', chapterNumber: 7, updateDate: '2026-02-26' },
      { id: 'ch-8', title: '第八章：宗门大比', chapterNumber: 8, updateDate: '2026-03-05' },
      { id: 'ch-9', title: '第九章：远古遗迹', chapterNumber: 9, updateDate: '2026-03-12' },
      { id: 'ch-10', title: '第十章：决战前夕', chapterNumber: 10, updateDate: '2026-03-19' },
      { id: 'ch-11', title: '第十一章：巅峰对决', chapterNumber: 11, updateDate: '2026-03-26' },
      { id: 'ch-12', title: '第十二章：新的征程', chapterNumber: 12, updateDate: '2026-04-02' },
    ],
  },
  {
    id: 'huoyan-zhanshen',
    title: '火焰战神',
    author: '烈焰之心',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Chinese%20manhua%20cover%20of%20a%20fierce%20young%20warrior%20with%20flames%20surrounding%20his%20fists%2C%20intense%20orange%20and%20red%20color%20palette%2C%20action%20pose%2C%20anime%20style%2C%20dramatic%20lighting%2C%20clean%20background%20with%20fire%20effects&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '在一个以火焰为尊的世界里，少年云炎天生拥有最纯净的火焰之力。被家族遗弃的他，凭借坚韧不拔的意志，一路逆袭成为令世人敬仰的火焰战神。',
    categories: ['rexue', 'xuanhuan', 'shaonian'],
    status: '连载中',
    rating: 9.4,
    views: 9820000,
    favorites: 720000,
    updateDate: '2026-08-02',
    chapters: [
      { id: 'hy-ch-1', title: '第一章：弃子', chapterNumber: 1, updateDate: '2026-02-01' },
      { id: 'hy-ch-2', title: '第二章：火焰觉醒', chapterNumber: 2, updateDate: '2026-02-08' },
      { id: 'hy-ch-3', title: '第三章：炼火之路', chapterNumber: 3, updateDate: '2026-02-15' },
      { id: 'hy-ch-4', title: '第四章：火灵契约', chapterNumber: 4, updateDate: '2026-02-22' },
      { id: 'hy-ch-5', title: '第五章：家族试炼', chapterNumber: 5, updateDate: '2026-03-01' },
    ],
  },
  {
    id: 'xingkong-lianren',
    title: '星空恋人',
    author: '月光下的猫',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20manhua%20cover%20showing%20a%20boy%20and%20girl%20under%20a%20starry%20night%20sky%2C%20soft%20purple%20and%20blue%20twilight%20tones%2C%20gentle%20expressions%2C%20anime%20art%20style%2C%20dreamy%20atmosphere%2C%20clean%20romantic%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '高中生林星和转学生苏月因为一次天文观测意外相遇，从此两颗孤独的心在星空下慢慢靠近。这是一段青涩而美好的校园恋爱故事。',
    categories: ['lianai', 'dushi', 'shaonian'],
    status: '已完结',
    rating: 9.7,
    views: 15600000,
    favorites: 1100000,
    updateDate: '2026-07-15',
    chapters: [
      { id: 'xk-ch-1', title: '第一章：流星雨之夜', chapterNumber: 1, updateDate: '2025-06-01' },
      { id: 'xk-ch-2', title: '第二章：转学生', chapterNumber: 2, updateDate: '2025-06-08' },
      { id: 'xk-ch-3', title: '第三章：天文社', chapterNumber: 3, updateDate: '2025-06-15' },
    ],
  },
  {
    id: 'kuangxiao-jianghu',
    title: '狂笑江湖',
    author: '笑三少',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20humorous%20Chinese%20manhua%20cover%20with%20a%20goofy%20young%20martial%20artist%20making%20a%20funny%20face%2C%20bright%20and%20playful%20colors%2C%20comic%20exaggerated%20expressions%2C%20anime%20style%2C%20lighthearted%20atmosphere%2C%20clean%20fun%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '一个不靠谱的小道士和他的奇葩师兄弟们，在江湖中闹出的一系列啼笑皆非的故事。这里有最搞笑的修真日常，让你笑到肚子疼！',
    categories: ['gaoxiao', 'xiuzhen', 'guzhuang'],
    status: '连载中',
    rating: 9.3,
    views: 8900000,
    favorites: 650000,
    updateDate: '2026-08-01',
    chapters: [
      { id: 'kx-ch-1', title: '第一章：下山', chapterNumber: 1, updateDate: '2026-03-01' },
      { id: 'kx-ch-2', title: '第二章：误入青楼', chapterNumber: 2, updateDate: '2026-03-08' },
      { id: 'kx-ch-3', title: '第三章：假扮大侠', chapterNumber: 3, updateDate: '2026-03-15' },
    ],
  },
  {
    id: 'anying-zhuizong',
    title: '暗影追踪',
    author: '暗夜行者',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Chinese%20manhua%20cover%20of%20a%20detective%20youth%20in%20a%20dark%20alley%2C%20noir%20atmosphere%2C%20shadowy%20figures%2C%20moody%20dark%20blue%20and%20gray%20tones%2C%20anime%20style%2C%20suspenseful%20composition%2C%20clean%20thriller%20aesthetic&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '天才少年侦探莫言拥有超凡的推理能力，每一桩看似不可能的案件在他手中都迎刃而解。然而，一个贯穿二十年的惊天阴谋正悄然浮出水面。',
    categories: ['xuanyi', 'dushi', 'kehuan'],
    status: '连载中',
    rating: 9.5,
    views: 7650000,
    favorites: 580000,
    updateDate: '2026-08-02',
    chapters: [
      { id: 'ay-ch-1', title: '第一章：消失的证人', chapterNumber: 1, updateDate: '2026-02-15' },
      { id: 'ay-ch-2', title: '第二章：密室之谜', chapterNumber: 2, updateDate: '2026-02-22' },
      { id: 'ay-ch-3', title: '第三章：第二个受害者', chapterNumber: 3, updateDate: '2026-03-01' },
    ],
  },
  {
    id: 'xingji-langzi',
    title: '星际浪子',
    author: '银河旅人',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20futuristic%20Chinese%20manhua%20cover%20of%20a%20young%20space%20adventurer%20with%20a%20high-tech%20suit%2C%20stars%20and%20galaxies%20in%20background%2C%20cool%20blue%20and%20silver%20tones%2C%20anime%20sci-fi%20style%2C%20clean%20futuristic%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '公元3000年，人类已经进入星际殖民时代。少年雷诺驾驶着自己改装的飞船，在浩瀚宇宙中开启了一段段惊心动魄的冒险旅程。',
    categories: ['kehuan', 'maoxian', 'shaonian'],
    status: '连载中',
    rating: 9.2,
    views: 6540000,
    favorites: 420000,
    updateDate: '2026-07-30',
    chapters: [
      { id: 'xj-ch-1', title: '第一章：启航', chapterNumber: 1, updateDate: '2026-03-10' },
      { id: 'xj-ch-2', title: '第二章：陨石带', chapterNumber: 2, updateDate: '2026-03-17' },
      { id: 'xj-ch-3', title: '第三章：废弃空间站', chapterNumber: 3, updateDate: '2026-03-24' },
    ],
  },
  {
    id: 'lingyu-dadi',
    title: '灵域大地',
    author: '域主大人',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Chinese%20manhua%20cover%20of%20a%20young%20cultivator%20standing%20on%20a%20floating%20mountain%2C%20magical%20energy%20swirling%2C%20ethereal%20green%20and%20golden%20tones%2C%20anime%20style%2C%20mystical%20atmosphere%2C%20clean%20fantasy%20composition&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '少年秦牧在灵域大地中觉醒远古血脉，从此踏上逆天改命的修行之路。万族争锋，群雄逐鹿，谁能问鼎灵域之巅？',
    categories: ['xuanhuan', 'xiuzhen', 'shaonian'],
    status: '连载中',
    rating: 9.5,
    views: 11200000,
    favorites: 850000,
    updateDate: '2026-08-03',
    chapters: [
      { id: 'ly-ch-1', title: '第一章：血脉觉醒', chapterNumber: 1, updateDate: '2026-01-10' },
      { id: 'ly-ch-2', title: '第二章：灵域之门', chapterNumber: 2, updateDate: '2026-01-17' },
      { id: 'ly-ch-3', title: '第三章：初入宗门', chapterNumber: 3, updateDate: '2026-01-24' },
      { id: 'ly-ch-4', title: '第四章：灵脉争夺', chapterNumber: 4, updateDate: '2026-01-31' },
    ],
  },
  {
    id: 'jinghun-yeyu',
    title: '惊魂夜语',
    author: '午夜说书人',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20horror%20Chinese%20manhua%20cover%20with%20a%20ghostly%20figure%20in%20an%20old%20mansion%2C%20eerie%20green%20and%20dark%20atmosphere%2C%20creepy%20vintage%20setting%2C%20anime%20horror%20style%2C%20clean%20spooky%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '每一个深夜，都有一段不为人知的诡异故事。收集民间灵异传说的青年作家，意外卷入了真实的超自然事件中。',
    categories: ['jingsong', 'xuanyi', 'dushi'],
    status: '已完结',
    rating: 9.1,
    views: 5430000,
    favorites: 380000,
    updateDate: '2026-06-20',
    chapters: [
      { id: 'jh-ch-1', title: '第一章：古宅哭声', chapterNumber: 1, updateDate: '2025-09-01' },
      { id: 'jh-ch-2', title: '第二章：镜中人', chapterNumber: 2, updateDate: '2025-09-08' },
      { id: 'jh-ch-3', title: '第三章：午夜脚步声', chapterNumber: 3, updateDate: '2025-09-15' },
    ],
  },
  {
    id: 'shenjian-chuanqi',
    title: '神剑传奇',
    author: '剑心问道',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20Chinese%20manhua%20cover%20of%20a%20young%20swordsman%20holding%20a%20glowing%20legendary%20sword%2C%20ancient%20Chinese%20landscape%20background%2C%20elegant%20flowing%20robes%2C%20anime%20style%2C%20heroic%20atmosphere%2C%20clean%20epic%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '上古神剑重现世间，引得天下英雄竞相争夺。少年剑客叶凡无意中得到神剑认可，从此卷入了一场关乎天下苍生的纷争。',
    categories: ['guzhuang', 'xuanhuan', 'shaonian'],
    status: '连载中',
    rating: 9.6,
    views: 13400000,
    favorites: 960000,
    updateDate: '2026-08-01',
    chapters: [
      { id: 'sj-ch-1', title: '第一章：剑出鞘', chapterNumber: 1, updateDate: '2026-01-05' },
      { id: 'sj-ch-2', title: '第二章：神剑认主', chapterNumber: 2, updateDate: '2026-01-12' },
      { id: 'sj-ch-3', title: '第三章：剑宗试剑', chapterNumber: 3, updateDate: '2026-01-19' },
    ],
  },
  {
    id: 'shiguang-lvxingzhe',
    title: '时光旅行者',
    author: '时间旅人',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20time%20travel%20Chinese%20manhua%20cover%20of%20a%20youth%20stepping%20through%20a%20clock%20portal%2C%20gears%20and%20clocks%20floating%2C%20warm%20bronze%20and%20golden%20tones%2C%20anime%20style%2C%20mysterious%20atmosphere%2C%20clean%20steampunk%20composition&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '普通大学生陆鸣偶然获得一块神秘怀表，从此拥有了穿梭时空的能力。但每一次穿越，都在悄然改变着他所在的现实世界。',
    categories: ['kehuan', 'maoxian', 'xuanyi'],
    status: '连载中',
    rating: 9.4,
    views: 8760000,
    favorites: 610000,
    updateDate: '2026-07-28',
    chapters: [
      { id: 'sg-ch-1', title: '第一章：神秘怀表', chapterNumber: 1, updateDate: '2026-02-20' },
      { id: 'sg-ch-2', title: '第二章：第一次穿越', chapterNumber: 2, updateDate: '2026-02-27' },
      { id: 'sg-ch-3', title: '第三章：蝴蝶效应', chapterNumber: 3, updateDate: '2026-03-06' },
    ],
  },
  {
    id: 'qingcheng-jueshang',
    title: '倾城绝裳',
    author: '霓裳羽衣',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20historical%20romance%20Chinese%20manhua%20cover%20of%20a%20graceful%20girl%20in%20traditional%20hanfu%20dress%2C%20ancient%20palace%20background%2C%20soft%20pink%20and%20gold%20tones%2C%20anime%20style%2C%20elegant%20atmosphere%2C%20clean%20romantic%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '大周王朝最负盛名的绣娘之女苏锦裳，以一手绝世绣技名动京城。但她真正的身份，却与二十年前的一场宫变息息相关。',
    categories: ['guzhuang', 'lianai', 'shaonian'],
    status: '已完结',
    rating: 9.8,
    views: 16700000,
    favorites: 1250000,
    updateDate: '2026-05-10',
    chapters: [
      { id: 'qc-ch-1', title: '第一章：绣娘之女', chapterNumber: 1, updateDate: '2025-03-01' },
      { id: 'qc-ch-2', title: '第二章：入宫', chapterNumber: 2, updateDate: '2025-03-08' },
      { id: 'qc-ch-3', title: '第三章：宫闱秘辛', chapterNumber: 3, updateDate: '2025-03-15' },
    ],
  },
  {
    id: 'jixie-jishi',
    title: '机械纪元',
    author: '齿轮工匠',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20steampunk%20Chinese%20manhua%20cover%20of%20a%20young%20mechanic%20with%20robotic%20arm%2C%20gears%20and%20steam%20engines%2C%20industrial%20revolution%20aesthetic%2C%20brass%20and%20copper%20tones%2C%20anime%20style%2C%20clean%20mechanical%20composition&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '在一个由蒸汽与齿轮驱动的世界里，少年工匠阿铁梦想打造出最强大的机械战士。当帝国的阴影笼罩大地，他必须用自己的发明来守护家园。',
    categories: ['kehuan', 'maoxian', 'shaonian'],
    status: '连载中',
    rating: 9.3,
    views: 7210000,
    favorites: 490000,
    updateDate: '2026-07-25',
    chapters: [
      { id: 'jx-ch-1', title: '第一章：废弃工厂', chapterNumber: 1, updateDate: '2026-03-15' },
      { id: 'jx-ch-2', title: '第二章：初代机甲', chapterNumber: 2, updateDate: '2026-03-22' },
      { id: 'jx-ch-3', title: '第三章：机械之心', chapterNumber: 3, updateDate: '2026-03-29' },
    ],
  },
];

export const faqData = [
  {
    question: '57漫画网的漫画都是免费的吗？',
    answer: '是的，57漫画网上所有的漫画内容均为免费阅读。我们致力于为广大漫画爱好者提供免费、高质量的漫画阅读体验，无需付费即可畅读蜜桃少年漫画全集及更多精彩作品。',
  },
  {
    question: '蜜桃少年漫画多久更新一次？',
    answer: '蜜桃少年漫画目前保持每周更新一话的频率。作者桃花仙人为保证作品质量，每一话都精心绘制，通常在每周五晚间更新，敬请关注57漫画网的最新动态。',
  },
  {
    question: '如何在57漫画网搜索想看的漫画？',
    answer: '您可以在57漫画网首页顶部的导航栏中找到搜索功能，输入漫画名称或关键词即可快速找到目标漫画。此外，您还可以通过分类页面按类型浏览，涵盖少年漫画、热血、玄幻、恋爱等多种类别。',
  },
  {
    question: '57漫画网支持手机阅读吗？',
    answer: '当然支持！57漫画网采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您使用什么设备，都能获得流畅舒适的漫画阅读体验。',
  },
  {
    question: '漫画加载慢或显示不全怎么办？',
    answer: '如果遇到漫画加载问题，建议您检查网络连接状态，或尝试刷新页面。如问题持续存在，您可以通过关于我们页面的联系方式与我们取得联系，我们会尽快协助您解决。',
  },
];

export const testimonials = [
  {
    name: '漫画迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20young%20Chinese%20person%20avatar%20illustration%2C%20simple%20flat%20style%2C%20warm%20smile%2C%20clean%20background%2C%20cartoon%20portrait&width=200&height=200&seq=avatar-01&orientation=squarish',
    comment: '57漫画网真的太棒了！蜜桃少年漫画我从第一话追到现在，画风精美，剧情引人入胜。而且完全免费，真心推荐给所有漫画爱好者！',
    rating: 5,
  },
  {
    name: '阅读达人阿明',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20young%20Chinese%20person%20avatar%20illustration%2C%20simple%20flat%20style%2C%20confident%20expression%2C%20clean%20background%2C%20cartoon%20portrait&width=200&height=200&seq=avatar-02&orientation=squarish',
    comment: '从大学开始就在57漫画网看漫画，现在已经工作三年了。网站的更新速度很快，分类也很齐全，基本上我想看的漫画这里都有。',
    rating: 5,
  },
  {
    name: '资深漫友小雨',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20young%20Chinese%20girl%20avatar%20illustration%2C%20simple%20flat%20style%2C%20cheerful%20smile%2C%20clean%20background%2C%20cartoon%20portrait&width=200&height=200&seq=avatar-03&orientation=squarish',
    comment: '对比了很多漫画网站，57漫画网的阅读体验是最好的。页面简洁没有乱七八糟的广告，加载速度快，收藏功能也很方便。五星好评！',
    rating: 5,
  },
];